import React from "react";
import { Link } from "react-router-dom";

export const mainParagraph = (
  <div className="mainParagraph">
    <p className="content justified">
      “—Y ésa, ésa es la muñeca de porcelana, Blondinette, la más bella de cuantas muñecas se han conocido. Tez de
      melocotón, ojos de cielo con estrellitas dentro de ellos. Voz de cristal y risa de fiestas”.
    </p>
    <p className="content justified">
      Blondinette vivía en un país de juguete, acompañada por su padre Juan Lanas, muñeco de aserrín; su hermana
      Pocoseso y su amiga Métome-en-todo, muñecas de pasta y de trapo, respectivamente; y su buen amigo Blondel, un
      payaso con corazón de caja de música.
    </p>
    <p className="content justified">
      Juan Lanas, dirigente de este país, tenía que lidiar con los atropellos de Lansquenete y de Nicolla, un soldado de
      plomo y un muñeco de goma, quienes querían hacer del país de juguete un lugar uniforme y rígido, en donde todos
      siguieran las mismas ideas, sin importar los medios para conseguirlo.
    </p>
    <p className="content justified">
      “Nada hay que sea cruel o malicioso cuando se lucha por un ideal. Aquí se establecerá una autoridad fuerte, una
      mano de plomo regirá y ordenará el país de los juguetes. Pronto todos desfilarán al mismo compás de mis soldados”,
      sostiene Lansquenete.
    </p>
  </div>
);

export const bottomParagraph = (
  <div className="bottomParagraph">
    <p className="content justified">
      Lisardo, el muñeco de palo recién llegado del bosque, fue la excusa perfecta para que Lansquenete pudiera llevar a
      cabo su plan en contra de Juan Lanas. Como Lisardo era de palo, moreno y oloroso a resinas del monte, Lansquenete
      le ordenó a Juan Lanas que lo desterrara, argumentando la falta de espacio en el lugar.
    </p>
    <p className="content justified">
      Sin embargo, Juan Lanas, Blondinette y Blondel estuvieron en contra de tal idea: “Nunca me he quejado de la falta
      de espacio aquí. Antes bien, noto que hay demasiado sin ocupar. Pensad en lo hermoso que sería esto lleno de
      muñecos. Muñecos de pasta, de porcelana, de aserrín, de celuloide, de goma, de palo, de cristal”, dice Juan Lanas.
    </p>
    <p className="content justified">
      Como Lisardo no fue expulsado del país de juguete, Lansquenete planeó una emboscada en contra de Juan Lanas y le
      ordenó a sus soldados que lo tildaran de loco y lo atacaran. Mientras tanto, Lisardo estaba pensando en volver al
      bosque y llevar a Blondinette con él y vivir allí por siempre a su lado, felices y en paz.
    </p>
    <p className="content justified">
      De repente, en medio del ataque a Juan Lanas, se desató un incendio. Lisardo tomó a Blondinette en uno de sus
      brazos y en el otro, a Blondel para escapar por la ventana. Qué sorpresa al enterarnos del destino final de
      Blondinette y Blondel: la muñeca de porcelana quebrada cruelmente por el golpe de la caída y el corazón de música
      del payaso roto por el impacto.
    </p>
  </div>
);

export const sections = (
  <div className="sectionsReview">
    <div className="sectionReview">
      <h3 className="review-title subtitle">
        <i>Blondinette</i>: entre los juguetes y el fascismo
      </h3>
      <p className="content justified">
        <i>Blondinette</i> –desarrollada en cuatro actos– es una de las más famosas obras de teatro escritas por Oswaldo
        Díaz Díaz. Ha sido catalogada para público infantil; sin embargo, dada su complejidad ideológica puede tener
        otros destinatarios. En sus dos primeros actos, se muestra el contexto en el cual se desarrollan las escenas,
        allí se describen los personajes y sus motivaciones. En los dos últimos actos, la acción se acelera, se
        presentan los hechos más impactantes y se llega al final en el que ninguno de los juguetes sale bien librado.
      </p>
      <p className="content justified">
        Esta es, sin duda, una obra con un carácter político marcado y evidente, no solo por los personajes de la
        historia, sus diálogos y las ideas que los fundamentan, sino por otros elementos proporcionados por el autor.
      </p>
      <p className="content justified">
        Por ejemplo, antes de entrar a la obra como tal, Díaz Díaz cuenta que la escribió durante la Segunda Guerra
        Mundial, época donde veía razas perseguidas, torturas y segregaciones, y que todo esto lo puso en un país de
        juguete. De ahí surgió <i>Blondinette</i>.
      </p>
      <p className="content justified">
        También son interesantes algunas de las ideas que aparecen en el prologuillo. Don Os dice que a medida que le da
        voz a los personajes, estos van adquiriendo vida, al punto que ya no sabe si los muñecos se parecen a los seres
        humanos, o los humanos a los juguetes.
      </p>
      <p className="content justified">
        “Pero advierto que, a pesar de esta independencia que mis criaturas adquieren casi a espaldas mías, el lugar de
        sus travesuras es siempre un país de juguete que no debe colocarse en ningún meridiano de los dos hemisferios y
        menos aun a los cuatro grados, treinta y cinco minutos y cincuenta y dos segundos al norte del Ecuador y a los
        setenta y cuatro grados, cuatro minutos y cincuenta y tres segundos al oeste del erudito meridiano de
        Greenwich”.
      </p>
      <p className="content justified">
        ¿Sabe el lector a qué lugar del mundo remiten esas coordenadas? Al hacer la búsqueda de esta ubicación precisa,
        nos encontramos con que se trata de Bogotá.
      </p>
      <p className="content justified">
        ¿Por qué ubicar la obra en Bogotá? O mejor, ¿por qué pedirle al lector explícitamente que no la ubique allí?
        ¿Por qué sugerir que las ideas gestantes de la Segunda Guerra Mundial y las acciones para perpetuarla podrían
        vivirse en tierras colombianas? ¿Son estos temas para el público infantil? ¿Los juguetes son solo para hablarle
        a los niños?
      </p>
      <p className="content justified">
        Muchas preguntas surgen de una obra tan compleja como <i>Blondinette</i>.
      </p>
      <p className="content justified">
        Por un lado, esta obra nos recuerda el cuento{" "}
        <Link className="orange" to="/obra/cambam-bali?color=orange">
          “Cambam Bali”
        </Link>
        , en el que los personajes son juguetes y las acciones ocurren en la hora maravillosa donde todos duermen. En{" "}
        <i>Blondinette</i>, también nos encontramos con muñecos y sus acciones suceden en la oscuridad; además, hay
        juguetes buenos y queridos por todos, y otros que desean lastimar a los demás para obtener algún beneficio,
        justo como pasa en el cuento en mención.
      </p>
      <p className="content justified">
        Por ello, podría pensarse que se trata de una obra para niños. Además, los diálogos no son tan extensos ni el
        lenguaje tan complejo como en algunas obras de teatro para adultos del mismo autor.
      </p>
      <p className="content justified">
        Sin embargo, teniendo en cuenta el tema desarrollado en <i>Blondinette</i> y el contexto del que bebió Díaz Díaz
        –Segunda Guerra Mundial, regímenes totalitarios y fascistas–, cabe preguntarse: ¿son asuntos dirigidos para un
        público infantil? Tal vez son temas más pertinentes para adultos. No obstante, en la primera mitad del siglo XX,
        no era común que el teatro en Colombia utilizara juguetes o muñecos para hablarle a los adultos, situación que
        ha cambiado en la actualidad.
      </p>
      <p className="content justified">
        Por todo lo anterior, consideramos que <i>Blondinette</i> es una obra que, a pesar de haber sido considerada
        tradicionalmente para niños, tiene en realidad un doble destinatario. De esta manera, Oswaldo Díaz Díaz sería un
        precursor del uso de elementos infantiles para hablarle a los adultos y de hablarle a los niños de temas que
        normalmente no se tocarían con ellos, teniendo en cuenta la noción de infancia de la época, marcada por la
        dulzura, la inocencia y la seguridad.
      </p>
    </div>
    <div className="sectionReview">
      <h3 className="review-title subtitle">En las tablas y en la radio</h3>
      <p className="content justified">
        <i>Blondinette</i> se terminó de escribir en julio de 1941. Fue estrenada en la Radiodifusora Nacional el
        domingo 17 de agosto del mismo año. Aquella noche, Oswaldo Díaz Díaz tuvo que interpretar el papel de Blondel.
        En este medio también se presentaron muchos de los radioteatros de Díaz Díaz, pues allí trabajó activamente como
        libretista.
      </p>
      <p className="content justified">
        Esta obra también fue publicada en una separata de la <i>Revista de Indias</i> en 1952 y fue traducida al inglés
        por Irving Benowitz. Ha sido representada varias veces en diferentes teatros de Bogotá y de Cali.
      </p>
      <p className="content justified">
        Recientemente, en 2017, fue llevada a las tablas por el Departamento de Arte Dramático de la Universidad Central
        en convenio con el Teatro Libre de Bogotá, en un homenaje a Díaz Díaz por el 50 aniversario de su muerte,
        organizado por la Academia Colombiana de Historia.
      </p>
      <p className="content justified">Esta fue, según Don Os, su obra predilecta.</p>
    </div>
  </div>
);
